import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Card, Col, Row } from 'antd';
import TableContextProvider, { useTableControls } from 'common/components/table/table-context';
import TableBase from 'common/components/table/table-base';
import '../community-information.scss';
import { PlusOutlined } from '@ant-design/icons';
import { trafficReportTableInitialColumns } from '../community-information.config';
import trafficReportService from 'common/services/traffic-report-service/traffic-report.service';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import AddTrafficReportModal from './traffic-report-modal/add-edit-traffic-report-modal';
import { useModal } from 'common/hooks/use-modal/use-modal.hook';
import ConfirmDeleteModal from 'common/components/modal/confirm-delete-modal/confirm-delete-modal';
import { IConfirmDeleteModalProps } from 'common/components/modal/confirm-delete-modal/confirm-delete-modal.types';

export const TrafficReport = observer(() => {
  const tableControls = useTableControls({
    onFetch: trafficReportService.getAll,
    initialColumns: trafficReportTableInitialColumns,
  });

  const deleteTrafficReportModal = useModal({
    onBeforeShow: (setModalInitData) => {
      const selectedRow = tableControls.getSelectedRow();

      if (!selectedRow?.id) {
        return;
      }

      const data: IConfirmDeleteModalProps = {
        message: 'Are you sure you want to delete this traffic report?',
        onDelete: () => {
          trafficReportService.delete(selectedRow.id).then(() => {
            deleteTrafficReportModal.hideModal(true);
          });
        },
      };

      setModalInitData(data);
    },
    onClose: (isDeleted) => {
      if (isDeleted) {
        tableControls.refetchData();
        tableControls.setSelectedRow(null);
      }
    },
  });

  const addTrafficReportModal = useModal({
    onClose: (isSuccessSaved?: boolean) => {
      if (isSuccessSaved) {
        tableControls.refetchData();
      }
    },
  });

  return (
    <Card className="eiq-card eiq-card-border eiq-configuration">
      <Row className="eiq-card-header">
        <Col span={24}>
          <h1 className="h1">Traffic reports configuration</h1>
        </Col>
      </Row>
      <TableContextProvider controls={tableControls}>
        <div className="gate-configuration-action-buttons">
          <Button icon={<PlusOutlined />} size="middle" onClick={addTrafficReportModal?.showModal}>
            Add
          </Button>
          <Button
            type="primary"
            className="button"
            onClick={deleteTrafficReportModal?.showModal}
            disabled={!tableControls.getSelectedRow()}
            icon={<DeleteIcon stroke="#F6F8FA" />}>
            Delete
          </Button>
        </div>
        <TableBase />
      </TableContextProvider>
      <AddTrafficReportModal
        title="Add"
        isEdit={false}
        initData={addTrafficReportModal?.initData}
        isOpen={addTrafficReportModal?.isOpenModal}
        onClose={addTrafficReportModal?.hideModal}
      />
      <ConfirmDeleteModal
        isEdit={false}
        initData={deleteTrafficReportModal?.initData}
        title="Delete"
        isOpen={deleteTrafficReportModal?.isOpenModal}
        onClose={deleteTrafficReportModal?.hideModal}
      />
    </Card>
  );
});
